module.exports = __webpack_public_path__ + "static/media/Cottonv2.0.05ac70ec.PNG";